"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function formatDate(date) {
    var y = date.getFullYear();
    var m = ('0' + (date.getMonth() + 1)).slice(-2);
    var d = ('0' + date.getDate()).slice(-2);
    return y + '-' + m + '-' + d;
}
function getFirstOfMonth() {
    var now = new Date();
    return formatDate(new Date(now.getFullYear(), now.getMonth(), 1));
}
var EcommerceDashboardController = /** @class */ (function () {
    function EcommerceDashboardController(ReportsModel) {
        this.ReportsModel = ReportsModel;
        this.dashboardData = null;
        this.loading = false;
        this.error = '';
        this.filters = {
            start_date: getFirstOfMonth(),
            end_date: formatDate(new Date()),
            granularity: 'monthly',
            yoy_type: 'same_period',
            top_products_limit: 10
        };
        this.onFilterChange = this.handleFilterChange.bind(this);
        this.fetchData();
    }
    EcommerceDashboardController.prototype.handleFilterChange = function (newFilters) {
        this.filters = newFilters;
        this.fetchData();
    };
    EcommerceDashboardController.prototype.fetchData = function () {
        var _this = this;
        this.loading = true;
        this.error = '';
        this.ReportsModel.getEcommerceDashboard(this.filters)
            .then(function (response) {
            _this.dashboardData = response.data;
            _this.loading = false;
        })
            .catch(function (err) {
            _this.error = 'Failed to load ecommerce dashboard data.';
            _this.loading = false;
        });
    };
    return EcommerceDashboardController;
}());
EcommerceDashboardController.$inject = ['ReportsModel'];
exports.default = EcommerceDashboardController;
